function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -28.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Keynote"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#1487FF",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#3E9CFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}), /*#__PURE__*/React.createElement("g", {
  id: "Paper",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.000000, 14.000000)",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.20096606,0.00158384204 L14.9152518,0.531480244 C15.5230622,0.564635182 16,1.10232239 16,1.75439694 L16,9.24557419 C16,9.89764877 15.5230622,10.435336 14.9152518,10.4684909 L5.20096606,10.9983873 C4.57059991,11.0327726 4.03357092,10.513129 4.00147824,9.83773071 C4.00049291,9.81699416 4,9.79623404 4,9.77547061 L4,1.22450054 C4,0.548227565 4.51167457,0 5.14285714,0 C5.16223617,0 5.18161211,0.000528118144 5.20096606,0.00158384204 Z",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.20096607,2.00158384 L12.9152518,2.53148024 C13.5230622,2.56463518 14,3.10232239 14,3.75439694 L14,11.2455742 C14,11.8976488 13.5230622,12.435336 12.9152518,12.4684909 L3.20096607,12.9983873 C2.57059991,13.0327726 2.03357092,12.513129 2.00147824,11.8377307 C2.00049291,11.8169942 2,11.796234 2,11.7754706 L2,3.22450054 C2,2.54822757 2.51167457,2 3.14285714,2 C3.16223619,2 3.1816121,2.00052811 3.20096607,2.00158384 Z",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.20096607,4.00158384 L10.9152518,4.53148024 C11.5230622,4.56463518 12,5.10232239 12,5.75439694 L12,13.2455742 C12,13.8976488 11.5230622,14.435336 10.9152518,14.4684909 L1.20096607,14.9983873 C0.570599914,15.0327726 0.0335709175,14.513129 0.00147823959,13.8377307 C0.00049290592,13.8169942 1.95852979e-17,13.796234 0,13.7754706 L2.53765263e-16,5.22450054 C1.76467691e-16,4.54822757 0.511674571,4 1.14285714,4 C1.16223619,4 1.1816121,4.00052811 1.20096607,4.00158384 Z"
})))))));

var SvgKeynote = function SvgKeynote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKeynote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/keynote.1770a0f5.svg";
export { ForwardRef as ReactComponent };